/**
 * Pup ID Theme JavaScript
 * Cart limits (membership qty 1 / physical max 5, no mix) live in
 * snippets/single-item-cart.liquid (loaded in <head> before Appstle / Shop Pay).
 */

document.addEventListener('DOMContentLoaded', function() {
  // Mobile menu toggle
  initMobileMenu();

  // Sticky header after slight scroll
  initStickyHeader();

  // Smooth scroll for anchor links
  initSmoothScroll();

  // FAQ accordion
  initFAQ();

  // Article page yellow accordion blocks
  initArticleAccordion();

  // Hero feature popups
  initFeaturePopups();

  // Story overlay image → play video
  initStoryOverlay();
});

/**
 * Sticky header — activates after a short scroll
 */
function initStickyHeader() {
  const section = document.getElementById('shopify-section-header');
  if (!section) return;

  const threshold = 80;
  let placeholder = null;
  let ticking = false;

  function update() {
    const shouldStick = window.scrollY > threshold;

    if (shouldStick && !section.classList.contains('is-sticky')) {
      placeholder = document.createElement('div');
      placeholder.className = 'header-sticky-placeholder';
      placeholder.setAttribute('aria-hidden', 'true');
      placeholder.style.height = section.offsetHeight + 'px';
      section.after(placeholder);
      section.classList.add('is-sticky');
    } else if (!shouldStick && section.classList.contains('is-sticky')) {
      section.classList.remove('is-sticky');
      if (placeholder) {
        placeholder.remove();
        placeholder = null;
      }
    }

    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  update();
}

/**
 * Mobile Menu
 */
function initMobileMenu() {
  const toggle = document.querySelector('.header__mobile-toggle');
  const menu = document.querySelector('.header__mobile-menu');
  const overlay = document.querySelector('.header__mobile-overlay');
  const close = document.querySelector('.header__mobile-close');

  if (!toggle || !menu) return;

  function openMenu() {
    menu.classList.add('active');
    if (overlay) overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    menu.classList.remove('active');
    if (overlay) overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  toggle.addEventListener('click', openMenu);

  if (close) {
    close.addEventListener('click', closeMenu);
  }

  if (overlay) {
    overlay.addEventListener('click', closeMenu);
  }

  menu.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', closeMenu);
  });

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') closeMenu();
  });
}

/**
 * Smooth Scroll
 */
function initSmoothScroll() {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (!target) return;

      e.preventDefault();
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
  });
}

/**
 * FAQ Accordion (accordion layout only)
 */
function initFAQ() {
  const items = document.querySelectorAll('.faq--accordion .faq-item');

  items.forEach(item => {
    const question = item.querySelector('.faq-item__question');
    const answer = item.querySelector('.faq-item__answer');
    if (!question || !answer) return;

    question.addEventListener('click', () => {
      const isActive = item.classList.contains('active');

      items.forEach(i => {
        i.classList.remove('active');
        const q = i.querySelector('.faq-item__question');
        const a = i.querySelector('.faq-item__answer');
        if (q) q.setAttribute('aria-expanded', 'false');
        if (a) a.hidden = true;
      });

      if (!isActive) {
        item.classList.add('active');
        question.setAttribute('aria-expanded', 'true');
        answer.hidden = false;
      }
    });
  });
}

/**
 * Article page yellow accordion blocks
 */
function initArticleAccordion() {
  const items = document.querySelectorAll('.article-accordion');
  if (!items.length) return;

  items.forEach(item => {
    const question = item.querySelector('.article-accordion__question');
    if (!question) return;

    question.addEventListener('click', () => {
      const isOpen = item.classList.contains('is-open');

      items.forEach(other => {
        other.classList.remove('is-open');
        const q = other.querySelector('.article-accordion__question');
        if (q) q.setAttribute('aria-expanded', 'false');
      });

      if (!isOpen) {
        item.classList.add('is-open');
        question.setAttribute('aria-expanded', 'true');
      }
    });
  });
}

/**
 * Feature popups (hero feature buttons)
 */
function initFeaturePopups() {
  const triggers = document.querySelectorAll('[data-popup-trigger]');
  if (!triggers.length) return;

  function openPopup(id) {
    const popup = document.getElementById(id);
    if (!popup) return;
    closeAllPopups();
    popup.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closePopup(popup) {
    if (!popup) return;
    popup.classList.remove('active');
    if (!document.querySelector('[data-popup].active')) {
      document.body.style.overflow = '';
    }
  }

  function closeAllPopups() {
    document.querySelectorAll('[data-popup].active').forEach(popup => {
      popup.classList.remove('active');
    });
    document.body.style.overflow = '';
  }

  triggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      const id = trigger.getAttribute('data-popup-trigger');
      if (id) openPopup(id);
    });
  });

  document.querySelectorAll('[data-popup-close]').forEach(btn => {
    btn.addEventListener('click', () => {
      closePopup(btn.closest('[data-popup]'));
    });
  });

  document.querySelectorAll('[data-popup]').forEach(popup => {
    popup.addEventListener('click', event => {
      if (event.target === popup) closePopup(popup);
    });
  });

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') closeAllPopups();
  });
}

/**
 * Video overlay image — click to hide overlay and play video (no play button)
 */
function initStoryOverlay() {
  document.querySelectorAll('[data-story-overlay], [data-product-video-overlay]').forEach((overlay) => {
    const root = overlay.closest('.story__media, .pupid-product-video__screen');
    if (!root) return;
    const video = root.querySelector('video');

    overlay.addEventListener('click', () => {
      overlay.classList.add('is-hidden');
      if (video) {
        video.controls = true;
        video.play().catch(() => {});
      }
    });

    if (video) {
      video.addEventListener('ended', () => {
        overlay.classList.remove('is-hidden');
        video.controls = false;
        video.currentTime = 0;
      });
    }
  });
}

/**
 * Designs/reviews carousels are below the fold — load after idle so they
 * stay off the mobile critical path (Lighthouse network dependency tree).
 */
(function loadThemeCarouselsWhenNeeded() {
  var loading = null;

  function carouselsSrc() {
    var el = document.querySelector('script[data-pupid-carousels]');
    return el ? el.getAttribute('data-pupid-carousels') : '';
  }

  function needsCarousels() {
    return !!(document.getElementById('designs-track') || document.getElementById('reviews-track'));
  }

  window.loadPupidCarousels = function () {
    if (window.__pupidCarouselsLoaded) return Promise.resolve();
    if (loading) return loading;
    var src = carouselsSrc();
    if (!src) return Promise.resolve();
    loading = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.onload = function () {
        window.__pupidCarouselsLoaded = true;
        resolve();
      };
      s.onerror = reject;
      document.body.appendChild(s);
    });
    return loading;
  };

  // Stub for inline onclick handlers until the carousel bundle arrives
  window.slideDesigns = function pupidSlideDesignsStub(direction) {
    window.loadPupidCarousels().then(function () {
      if (window.slideDesigns !== pupidSlideDesignsStub) {
        window.slideDesigns(direction);
      }
    });
  };

  window.slideReviews = function pupidSlideReviewsStub(direction) {
    window.loadPupidCarousels().then(function () {
      if (window.slideReviews !== pupidSlideReviewsStub) {
        window.slideReviews(direction);
      }
    });
  };

  function schedule() {
    if (!needsCarousels()) return;
    var run = function () { window.loadPupidCarousels(); };
    if ('requestIdleCallback' in window) {
      requestIdleCallback(run, { timeout: 2500 });
    } else {
      window.addEventListener('load', function () { setTimeout(run, 1); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();

